import { useContext, useState } from "react";
import { ConfirmAction, Modal } from "components/ui";
import { ToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";

const { ERROR } = dataQueryStatus;

const DeleteAutomationModal = ({
    showModal,
    closeModal,
    handleSuccess,
    selectedAutomation,
}) => {
    const [loading, setLoading] = useState(false);
    const toastMessage = useContext(ToastContext);

    const deleteAutomation = async () => {
        try {
            setLoading(true);
            const url = apiRoute.deleteAutomation(
                selectedAutomation?.automationId
            );
            const res = await API.delete(url);

            if (res.status === 200) {
                toastMessage(res?.data?.message || "Automation deleted");
                handleSuccess?.();
                closeModal?.();
            }
        } catch (err) {
            setLoading(false);
            toastMessage(getErrorMessage(err), ERROR);
        }
    };

    return (
        <Modal show={showModal} close={closeModal}>
            <ConfirmAction
                title={`Are you sure you want to delete "${
                    selectedAutomation?.name || "this automation"
                }"?`}
                loading={loading}
                close={closeModal}
                handleYesClick={deleteAutomation}
            />
        </Modal>
    );
};

export default DeleteAutomationModal;
